/**
 * bic-bim-api
 * Import from bic-bim-api Function App
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Eine einzelne Informationsanforderung innerhalb einer Prüfregel
 */
export interface LoiCheck { 
    /**
     * Eindeutige ID des Checks (optional)
     */
    id?: string;
    /**
     * Property Set Name
     */
    pset: string;
    /**
     * Property Name
     */
    property: string;
    /**
     * Vergleichsoperator
     */
    operator: LoiCheck.OperatorEnum;
    /**
     * Vergleichswert (String, Zahl oder Array je nach Operator)
     */
    value: string | number | Array<string>;
}
export namespace LoiCheck {
    export type OperatorEnum = '' | 'equals' | 'not_equals' | 'exists' | 'one_of' | 'not_one_of' | 'contains' | 'not_contains' | 'greater' | 'greater_equals' | 'lower' | 'lower_equals';
    export const OperatorEnum = {
        Empty: '' as OperatorEnum,
        Equals: 'equals' as OperatorEnum,
        NotEquals: 'not_equals' as OperatorEnum,
        Exists: 'exists' as OperatorEnum,
        OneOf: 'one_of' as OperatorEnum,
        NotOneOf: 'not_one_of' as OperatorEnum,
        Contains: 'contains' as OperatorEnum,
        NotContains: 'not_contains' as OperatorEnum,
        Greater: 'greater' as OperatorEnum,
        GreaterEquals: 'greater_equals' as OperatorEnum,
        Lower: 'lower' as OperatorEnum,
        LowerEquals: 'lower_equals' as OperatorEnum
    };
}